var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgLogo = function SvgLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88.109474pt",
    height: "24.000002pt",
    viewBox: "0 0 88.109474 23.99999",
    id: "svg122",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs57"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 41.141014,
    y1: -222.45853,
    x2: 345.6153,
    y2: 215.3643,
    id: "linearGradient-1",
    gradientTransform: "scale(0.46726591,2.140109)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CFE95",
    offset: "0%",
    id: "stop22"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3DC",
    offset: "100%",
    id: "stop24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -2395.2849,
    y1: -11.406087,
    x2: 10186.863,
    y2: 440.12521,
    id: "linearGradient-2",
    gradientTransform: "scale(1.1756222,0.85061341)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CFE95",
    offset: "0%",
    id: "stop27"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3DC",
    offset: "100%",
    id: "stop29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -2338.5247,
    y1: -301.185,
    x2: 12521.781,
    y2: 430.14694,
    id: "linearGradient-3",
    gradientTransform: "scale(1.086374,0.92049334)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CFE95",
    offset: "0%",
    id: "stop32"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3DC",
    offset: "100%",
    id: "stop34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -1307.7672,
    y1: -64.016083,
    x2: 10824.579,
    y2: 441.51001,
    id: "linearGradient-4",
    gradientTransform: "scale(1.1325343,0.88297548)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CFE95",
    offset: "0%",
    id: "stop37"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3DC",
    offset: "100%",
    id: "stop39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -1429.7102,
    y1: -267.52896,
    x2: 13685.545,
    y2: 425.38324,
    id: "linearGradient-5",
    gradientTransform: "scale(1.1058224,0.90430438)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CFE95",
    offset: "0%",
    id: "stop42"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3DC",
    offset: "100%",
    id: "stop44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -0.80384994,
    y1: 0,
    x2: 2.4704731,
    y2: 2.0614839,
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CFE95",
    offset: "0%",
    id: "stop47"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3DC",
    offset: "100%",
    id: "stop49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -0.79964066,
    y1: 0,
    x2: 2.4641116,
    y2: 2.0614839,
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CFE95",
    offset: "0%",
    id: "stop52"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3DC",
    offset: "100%",
    id: "stop54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-6",
    id: "linearGradient2616",
    x1: 506.61688,
    y1: 0.62813562,
    x2: 1239.8372,
    y2: 462.25693,
    gradientTransform: "scale(0.93161544,1.0734043)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-6",
    id: "linearGradient2618",
    x1: 730.54724,
    y1: 112.75035,
    x2: 1463.7675,
    y2: 574.37915,
    gradientTransform: "scale(0.93161544,1.0734043)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-6",
    id: "linearGradient2620",
    x1: 506.61688,
    y1: 224.55849,
    x2: 1239.8372,
    y2: 686.18732,
    gradientTransform: "scale(0.93161544,1.0734043)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-6",
    id: "linearGradient2622",
    x1: 730.54724,
    y1: 336.68069,
    x2: 1463.7675,
    y2: 798.30951,
    gradientTransform: "scale(0.93161544,1.0734043)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-6",
    id: "linearGradient2624",
    x1: 506.61688,
    y1: 448.48883,
    x2: 1239.8372,
    y2: 910.11768,
    gradientTransform: "scale(0.93161544,1.0734043)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-6",
    id: "linearGradient2626",
    x1: 730.54724,
    y1: 560.61108,
    x2: 1463.7675,
    y2: 1022.2399,
    gradientTransform: "scale(0.93161544,1.0734043)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-6",
    id: "linearGradient2628",
    x1: -72.201477,
    y1: 217.02086,
    x2: 661.0188,
    y2: 678.64966,
    gradientTransform: "scale(0.93161544,1.0734043)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-7",
    id: "linearGradient2630",
    x1: 211.7372,
    y1: 300.0062,
    x2: 941.99982,
    y2: 761.26196,
    gradientTransform: "scale(0.93086262,1.0742724)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-6",
    id: "linearGradient2632",
    x1: 44.285713,
    y1: 441.89343,
    x2: 777.50604,
    y2: 903.52222,
    gradientTransform: "scale(0.93161544,1.0734043)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-7",
    id: "linearGradient2634",
    x1: 193.27245,
    y1: 610.36829,
    x2: 923.53503,
    y2: 1071.6241,
    gradientTransform: "scale(0.93086262,1.0742724)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-7",
    id: "linearGradient2636",
    x1: 506.44919,
    y1: 706.70917,
    x2: 1236.7118,
    y2: 1167.965,
    gradientTransform: "scale(0.93086262,1.0742724)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-7",
    id: "linearGradient2638",
    x1: 249.02876,
    y1: 189.54367,
    x2: 979.29138,
    y2: 650.79944,
    gradientTransform: "scale(0.93086262,1.0742724)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-6",
    id: "linearGradient2640",
    x1: 282.68652,
    y1: 0.62813562,
    x2: 1015.9068,
    y2: 462.25696,
    gradientTransform: "scale(0.93161544,1.0734043)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-6",
    id: "linearGradient2642",
    x1: 23.665312,
    y1: 95.790688,
    x2: 756.88562,
    y2: 557.41949,
    gradientTransform: "scale(0.93161544,1.0734043)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-6",
    id: "linearGradient2644",
    x1: 247.59566,
    y1: 206.65662,
    x2: 980.81598,
    y2: 668.2854,
    gradientTransform: "scale(0.93161544,1.0734043)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-6",
    id: "linearGradient2646",
    x1: -14.681406,
    y1: 300.24884,
    x2: 718.53888,
    y2: 761.87762,
    gradientTransform: "scale(0.93161544,1.0734043)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-7",
    id: "linearGradient2648",
    x1: 284.51007,
    y1: 448.12643,
    x2: 1014.7727,
    y2: 909.3822,
    gradientTransform: "scale(0.93086262,1.0742724)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-6",
    id: "linearGradient2650",
    x1: -179.64464,
    y1: 500.62411,
    x2: 553.57568,
    y2: 962.25293,
    gradientTransform: "scale(0.93161544,1.0734043)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-6",
    id: "linearGradient2652",
    x1: 730.54724,
    y1: 224.55849,
    x2: 1463.7675,
    y2: 686.18732,
    gradientTransform: "scale(0.93161544,1.0734043)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-6",
    id: "linearGradient2654",
    x1: 506.61688,
    y1: 336.68069,
    x2: 1239.8372,
    y2: 798.30951,
    gradientTransform: "scale(0.93161544,1.0734043)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-6",
    id: "linearGradient2656",
    x1: 730.54724,
    y1: 448.48883,
    x2: 1463.7675,
    y2: 910.11768,
    gradientTransform: "scale(0.93161544,1.0734043)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-6",
    id: "linearGradient2658",
    x1: 506.61688,
    y1: 560.61102,
    x2: 1239.8372,
    y2: 1022.2399,
    gradientTransform: "scale(0.93161544,1.0734043)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-6",
    id: "linearGradient2660",
    x1: 233.1252,
    y1: 653.88916,
    x2: 966.34552,
    y2: 1115.5179,
    gradientTransform: "scale(0.93161544,1.0734043)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient-6",
    id: "linearGradient2662",
    x1: 506.61688,
    y1: 112.75035,
    x2: 1239.8372,
    y2: 574.37915,
    gradientTransform: "scale(0.93161544,1.0734043)",
    gradientUnits: "userSpaceOnUse"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(0.02402663,0,0,0.02402663,-0.00809836,-0.0162001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-8750,-2890)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(8750,2890)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1300,276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 86.179949,0.67482149 c 9.778747,0 14.499521,4.72375041 14.499521,14.50866151 V 446.39441 c 0,9.78491 -4.720774,14.50866 -14.499521,14.50866 H 15.368332 c -10.1159452,0 -15.17391785,-4.72375 -15.17391785,-14.50866 V 15.183483 c 0,-9.7849111 5.05797265,-14.50866151 15.17391785,-14.50866151 z",
    id: "Shape",
    fill: "url(#linearGradient-1)",
    style: {
      fill: "url(#linearGradient-1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 522.17719,99.87358 c 29.33624,0 53.95171,2.36188 74.1836,7.42304 20.23189,5.06116 36.0802,12.8216 48.21934,23.61875 12.13913,10.79714 20.56909,24.63098 25.96426,41.50152 5.39517,16.87054 7.75555,37.11518 7.75555,60.73393 v 94.47501 c 0,23.61875 -2.69758,43.8634 -7.75555,60.73393 -5.39517,16.87054 -13.82513,30.70438 -25.96426,41.50153 -12.13914,10.79714 -28.32465,18.55759 -48.21934,23.28134 -20.23189,4.72375 -44.84736,7.08562 -74.1836,7.08562 h -185.7962 c -29.67343,0 -54.6261,-2.36187 -74.52079,-7.08562 -19.89469,-4.72375 -36.08021,-12.4842 -47.88214,-23.28134 -12.13914,-10.79715 -20.56909,-24.63099 -25.96426,-41.50153 -5.05798,-16.87053 -7.75556,-37.11518 -7.75556,-60.73393 v -94.47501 c 0,-23.61875 2.69758,-43.86339 7.75556,-60.73393 5.39517,-16.87054 13.82512,-30.70438 25.96426,-41.50152 12.13913,-10.79715 27.98745,-18.55759 47.88214,-23.61875 19.89469,-5.06116 44.84736,-7.42304 74.52079,-7.42304 z M 273.99933,311.43011 c 0,14.17126 1.0116,25.64322 3.37198,34.75331 2.36039,9.11009 6.06957,16.53313 11.46474,21.9317 5.39517,5.39857 12.81353,9.4475 21.91788,11.80938 9.10435,2.36187 20.90629,3.71151 34.73141,3.71151 h 167.5875 c 14.49952,0 26.30146,-1.01223 35.40581,-3.71151 9.10435,-2.36188 16.52271,-6.41081 21.91788,-11.80938 5.39517,-5.39857 9.44155,-12.82161 11.46474,-21.9317 2.36038,-9.11009 3.37198,-20.91946 3.37198,-34.75331 v -62.42098 c 0,-13.49643 -1.0116,-24.9684 -3.37198,-34.07849 -2.36039,-9.11009 -6.06957,-16.53312 -11.46474,-22.26911 -5.39517,-5.73598 -12.81353,-9.78491 -21.91788,-11.80937 -9.10435,-2.02447 -20.90629,-3.37411 -35.40581,-3.37411 h -167.5875 c -14.16232,0 -25.62706,1.01223 -34.73141,3.37411 -9.10435,2.36187 -16.52271,6.07339 -21.91788,11.80937 -5.39517,5.73599 -9.44155,13.15902 -11.46474,22.26911 -2.36038,9.11009 -3.37198,20.58206 -3.37198,34.07849 z",
    id: "path60",
    fill: "url(#linearGradient-2)",
    style: {
      fill: "url(#linearGradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1257.9436,0.67482149 c 10.116,0 15.1739,4.72375041 15.1739,14.50866151 v 64.445452 c 0,10.122322 -5.0579,15.183484 -15.1739,15.183484 H 1051.5783 V 446.39441 c 0,9.78491 -4.7207,14.50866 -14.4995,14.50866 h -71.48601 c -9.77875,0 -14.49952,-4.72375 -14.49952,-14.50866 V 94.475008 H 744.72798 c -10.11594,0 -15.17391,-5.061161 -15.17391,-15.183484 V 14.846073 c 0,-9.7849119 5.05797,-14.50866226 15.17391,-14.50866226 h 513.21562 z",
    id: "path62",
    fill: "url(#linearGradient-3)",
    style: {
      fill: "url(#linearGradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1650.7795,99.87358 c 22.2551,0 40.801,1.68705 55.6377,5.39857 14.8367,3.71152 26.3014,9.78491 34.7314,18.55759 8.43,8.43527 14.4995,19.56983 18.2087,33.40367 3.372,13.83384 5.3952,30.70437 5.3952,50.2742 v 62.42098 c 0,14.17126 -3.0348,23.61876 -9.1044,29.35474 -6.0695,5.39857 -15.5111,8.09786 -28.3246,8.09786 h -331.803 v 15.8583 c 0,20.58206 5.0579,35.42813 14.8367,44.53822 9.7787,9.11009 28.999,13.83384 57.3237,13.83384 h 273.8049 c 7.7556,0 11.8019,4.04893 11.8019,11.80938 v 55.33536 c 0,7.76044 -4.0463,11.80937 -11.8019,11.80937 h -283.2465 c -29.6734,0 -54.6261,-2.36187 -74.5208,-7.08562 -19.8947,-4.72375 -35.743,-12.4842 -47.8821,-23.28134 -12.1391,-10.79715 -20.5691,-24.63099 -25.9643,-41.50152 -5.3951,-16.87054 -7.7555,-37.11519 -7.7555,-60.73394 v -94.47501 c 0,-23.61875 2.6976,-43.86339 7.7555,-60.73393 5.3952,-16.87054 13.8252,-30.70438 25.9643,-41.50152 12.1391,-10.79714 27.9874,-18.55759 47.8821,-23.61875 19.8947,-5.06116 44.8474,-7.42304 74.5208,-7.42304 h 192.5402 z m -255.5962,149.13555 h 266.0493 c 7.4184,0 11.1276,-3.71152 11.1276,-11.13456 v -27.66768 c 0,-13.49643 -2.6976,-23.28134 -8.43,-29.01732 -5.7324,-5.73598 -16.1855,-8.43527 -31.3594,-8.43527 h -164.8899 c -28.3247,0 -47.545,4.38634 -57.3237,13.49643 -9.7788,9.11009 -14.8367,23.95616 -14.8367,44.87563 v 17.88277 z",
    id: "path64",
    fill: "url(#linearGradient-4)",
    style: {
      fill: "url(#linearGradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2348.1053,0.67482149 c 6.0696,0 9.4416,2.02446441 10.116,6.41080411 0.6744,4.0489294 -0.6744,7.7604474 -3.7092,10.7971434 l -201.6445,204.470911 210.7488,221.34145 c 3.0348,3.03669 4.3836,6.74821 3.7092,10.79714 -0.6744,4.04893 -4.0464,6.4108 -10.1159,6.4108 h -90.032 c -5.3951,0 -9.4415,-0.67482 -12.4763,-2.02446 -3.0348,-1.34964 -6.0695,-3.71152 -8.4299,-7.08563 L 2084.0791,281.73797 1921.2124,451.79298 c -3.0348,3.37411 -6.0695,6.0734 -8.7671,7.08563 -2.6976,1.34964 -7.0812,2.02446 -12.8136,2.02446 h -85.3111 c -5.7324,0 -8.7672,-2.02446 -9.4415,-6.4108 -0.6744,-4.04893 0.6743,-7.76045 3.7091,-10.79714 L 2024.7323,218.97957 1829.8317,17.882769 c -2.6976,-3.036696 -3.7092,-6.748214 -3.372,-10.7971434 0.3372,-4.0489289 3.7092,-6.41080411 9.7788,-6.41080411 h 90.0319 c 5.3952,0 9.4415,0.67482151 12.4763,2.36187521 3.0348,1.3496429 6.0696,3.7115181 8.43,6.7482148 L 2090.4859,162.29457 2242.2251,9.7849115 c 2.6976,-3.0366967 5.3952,-5.3985719 8.4299,-6.7482148 3.0348,-1.6870537 7.0812,-2.36187521 12.4764,-2.36187521 z",
    id: "path66",
    fill: "url(#linearGradient-5)",
    style: {
      fill: "url(#linearGradient-5)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g117"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon69",
    fill: "url(#linearGradient-6)",
    points: "639.66885,241.04204 848.28582,121.0267 639.66885,0.67424348 ",
    style: {
      fill: "url(#linearGradient2616)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon71",
    fill: "url(#linearGradient-6)",
    opacity: 0.9,
    points: "848.28582,361.3945 1056.9028,241.04204 848.28582,121.0267 ",
    style: {
      fill: "url(#linearGradient2618)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon73",
    fill: "url(#linearGradient-6)",
    opacity: 0.8,
    points: "639.66885,481.40984 848.28582,361.3945 639.66885,241.04204 ",
    style: {
      fill: "url(#linearGradient2620)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon75",
    fill: "url(#linearGradient-6)",
    opacity: 0.8,
    points: "848.28582,601.7623 1056.9028,481.40984 848.28582,361.3945 ",
    style: {
      fill: "url(#linearGradient2622)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon77",
    fill: "url(#linearGradient-6)",
    opacity: 0.8,
    points: "639.66885,721.77764 848.28582,601.7623 639.66885,481.40984 ",
    style: {
      fill: "url(#linearGradient2624)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon79",
    fill: "url(#linearGradient-6)",
    points: "848.28582,842.1301 1056.9028,721.77764 848.28582,601.7623 ",
    style: {
      fill: "url(#linearGradient2626)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon81",
    fill: "url(#linearGradient-6)",
    opacity: 0.4,
    points: "100.43273,473.31892 309.0497,352.96646 100.43273,232.95112 ",
    style: {
      fill: "url(#linearGradient2628)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon83",
    fill: "url(#linearGradient-7)",
    opacity: 0.2,
    points: "363.64736,562.65618 571.92731,442.64084 363.64736,322.28838 ",
    style: {
      fill: "url(#linearGradient2630)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon85",
    fill: "url(#linearGradient-6)",
    opacity: 0.3,
    points: "208.954,714.69809 417.57097,594.34563 208.954,474.33029 ",
    style: {
      fill: "url(#linearGradient2632)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon87",
    fill: "url(#linearGradient-7)",
    opacity: 0.9,
    points: "346.45921,896.06958 554.73916,775.71712 346.45921,655.70178 ",
    style: {
      fill: "url(#linearGradient2634)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon89",
    fill: "url(#linearGradient-7)",
    opacity: 0.7,
    points: "637.98374,999.56596 846.26369,879.21349 637.98374,759.19816 ",
    style: {
      fill: "url(#linearGradient2636)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon91",
    fill: "url(#linearGradient-7)",
    opacity: 0.9,
    points: "398.36068,443.98933 606.64064,323.97399 398.36068,203.62153 ",
    style: {
      fill: "url(#linearGradient2638)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon93",
    fill: "url(#linearGradient-6)",
    opacity: 0.8,
    points: "639.66885,241.04204 431.05187,121.0267 639.66885,0.67424348 ",
    style: {
      fill: "url(#linearGradient2640)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon95",
    fill: "url(#linearGradient-6)",
    opacity: 0.6,
    points: "398.36068,343.18993 189.74371,222.83747 398.36068,102.82213 ",
    style: {
      fill: "url(#linearGradient2642)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon97",
    fill: "url(#linearGradient-6)",
    opacity: 0.6,
    points: "606.97766,462.1939 398.36068,341.84144 606.97766,221.8261 ",
    style: {
      fill: "url(#linearGradient2644)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon99",
    fill: "url(#linearGradient-6)",
    opacity: 0.95,
    points: "362.63629,562.65618 154.01932,442.64084 362.63629,322.28838 ",
    style: {
      fill: "url(#linearGradient2646)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon101",
    fill: "url(#linearGradient-7)",
    opacity: 0.6,
    points: "639.66885,721.77764 431.3889,601.7623 639.66885,481.40984 ",
    style: {
      fill: "url(#linearGradient2648)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon103",
    fill: "url(#linearGradient-6)",
    opacity: 0.55,
    points: "208.954,777.73985 0.33702258,657.38739 208.954,537.37205 ",
    style: {
      fill: "url(#linearGradient2650)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon105",
    fill: "url(#linearGradient-6)",
    points: "1056.9028,481.40984 848.28582,361.3945 1056.9028,241.04204 ",
    style: {
      fill: "url(#linearGradient2652)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon107",
    fill: "url(#linearGradient-6)",
    opacity: 0.95,
    points: "848.28582,601.7623 639.66885,481.40984 848.28582,361.3945 ",
    style: {
      fill: "url(#linearGradient2654)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon109",
    fill: "url(#linearGradient-6)",
    opacity: 0.9,
    points: "1056.9028,721.77764 848.28582,601.7623 1056.9028,481.40984 ",
    style: {
      fill: "url(#linearGradient2656)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon111",
    fill: "url(#linearGradient-6)",
    opacity: 0.7,
    points: "848.28582,842.1301 639.66885,721.77764 848.28582,601.7623 ",
    style: {
      fill: "url(#linearGradient2658)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon113",
    fill: "url(#linearGradient-6)",
    opacity: 0.4,
    points: "593.49676,942.25526 384.87978,822.23992 593.49676,701.88746 ",
    style: {
      fill: "url(#linearGradient2660)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon115",
    fill: "url(#linearGradient-6)",
    points: "848.28582,361.3945 639.66885,241.04204 848.28582,121.0267 ",
    style: {
      fill: "url(#linearGradient2662)"
    }
  }))))));
};
export default SvgLogo;